import { render, staticRenderFns } from "./voteTable.vue?vue&type=template&id=f6acf91c&scoped=true"
import script from "./voteTable.vue?vue&type=script&lang=js"
export * from "./voteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6acf91c",
  null
  
)

export default component.exports